export function setNullDataDesign(flag, context) {
    const _dataTable = document.getElementsByClassName('dataTable').item(0);
    if (_dataTable && flag && context.data.rows && context.data.rows.length === 0) {
        const _td = _dataTable.children.item(1).childNodes.item(0).childNodes.item(0);
        _td.style.height = '180px';
        _td.style.opacity = 0;
    }
}